import React, { Component } from 'react'
import PropTypes from 'prop-types'
import R, { isEmpty, isNil } from 'ramda'
import moment from 'moment'
import { Colors, Icon as OriginalIcon } from 'advenio-components'
import { initializeFirebase, onMessageListener, requestForToken} from "../../firebase";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import ProfilePicture from './ProfilePicture'
import {
  ChildrenContainer,
  ChildrenDiv,
  StatusDiv,
  ProfileDiv,
  InfoDiv,
  NameDiv,
  InformationDiv,
  Img,
  Status,
  IconsDiv,
  ActionButton,
  InfoDivOverlay,
  ProfileDivOverlay,
  StudyProgramPill,
  CheckoutPill,
} from './ChildrenList.styles'
import Tabs from '../Tabs'
import { isTeacher, getCookie } from '../../utils/Utils'
import { async } from 'regenerator-runtime'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

const Icon = ({ height, type, width }) => (
  <OriginalIcon
    type={type}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    color={type === 'logIn' ? Colors.gray700 : Colors.gray500}
  />
)

Icon.propTypes = {
  height: PropTypes.number,
  type: PropTypes.string.isRequired,
  width: PropTypes.number,
}

Icon.defaultProps = {
  height: 24,
  width: 24,
}


class ChildrenList extends Component {

  // descomment when FCM is ready
  componentWillMount(){
    // isSupported().then(response => {
    //   if (response){
    //     const messaging = getMessaging();
    //     onMessage(messaging, (payload) => {
    //       this.props.setCheckout(payload.data.child_id, payload.data.classroom_id, payload.data.action)
    //     });
    //   }
    // })
  }

  getActiveChildren() {
    const newChildren = R.clone(this.props.children.filter(
      student => (student.checkin && student.checkin.id !== null)))
    const kidsToShow = newChildren.filter(student => !student.deleted_at).sort((a) => a.isComingCheckout ? -1 : 1 )

    return kidsToShow.map((student) => {
      const { checkin, id: studentId } = student
      const checkinStatus = checkin.id === null ? 'Inactive' : checkin.status
      const isNotCheckedIn = checkin.status === 'Inactive'
        || checkin.status === 'Home'
        || checkin.id === null
      const studyProgram = this.getStudyProgram(student.study_program_id)
      return (
        <ChildrenDiv key={studentId} type={checkinStatus} isComingCheckout={ student.isComingCheckout} isCloud={checkin.is_virtual_center}>
          <StatusDiv type={checkinStatus} isComingCheckout={ student.isComingCheckout}  isCloud={checkin.is_virtual_center} />
          <ProfileDiv onClick={this.viewProfile} >
            <ProfileDivOverlay id={studentId} onClick={this.viewProfile} />
            <ProfilePicture
              profile_image={student.profile_pictures ? student.profile_pictures['original'] : '/assets/BabyAvatar.svg'}
              type={checkinStatus}
            />
          </ProfileDiv>
          <InfoDiv>
            <InfoDivOverlay id={studentId} onClick={this.viewProfile} />
            <NameDiv>
              {checkin.is_virtual_center && <Img src="/assets/Cloud.svg" alt="type" style={{ marginRight: '2px' }} />}
              <span>{student.first_name} {student.last_name_paternal}</span>
              {studyProgram && <StudyProgramPill>{studyProgram}</StudyProgramPill>}
              {student.pendingPayments && <Img src="/assets/Warning.svg" alt="type" />}
            </NameDiv>
            <InformationDiv>
              {!isNotCheckedIn && this.renderCurrentActivity(student.latest_activities)}
              {(student.isComingCheckout) &&  <CheckoutPill>{`Hicieron checkout próximo a las ${moment(student.isComingCheckout).format('H:mm:ss')}, en un momento llegarán por el bebe`}</CheckoutPill>}
              {(student.isComingCancel) &&  <CheckoutPill>{student.isComingCancel}</CheckoutPill>}
            </InformationDiv>
          </InfoDiv>
          {isNotCheckedIn ?
            <IconsDiv>
              {!checkin.is_virtual_center &&(
                <ActionButton onClick={this.openAssessmentModal(studentId)}>
                  <Icon type="logIn" />
                </ActionButton>
              )}
            </IconsDiv>
            :
            <IconsDiv>
              <ActionButton onClick={this.checkOut(studentId)}>
                <Icon type="logOut" />
              </ActionButton>
              {!checkin.is_virtual_center && this.childIsDayCareAge(student.study_program_id) && (
                <ActionButton onClick={this.checkIn(studentId)}>
                  <Icon type={checkin.inventory_completed ? 'inventory' : 'inventoryPending'} height={30} width={30} />
                </ActionButton>
              )}
              {this.props.categories.length > 0 && (
                <React.Fragment>
                {this.props.director
                  && (
                    <ActionButton onClick={this.addActivity(studentId)}>
                      <Icon type="startActivity" />
                    </ActionButton>
                  )
                }
                {!this.props.director
                  && !this.props.nurse
                  && checkin.status !== "Nurse's Room" && checkin.status !== "Virtual Center - Nurse's Room" && !this.props.isSickRoom
                  && (
                    <ActionButton onClick={this.addActivity(studentId)}>
                      <Icon type="startActivity" />
                    </ActionButton>
                  )
                }
                {!this.props.director
                  && (checkin.status === "Nurse's Room" || checkin.status === "Virtual Center - Nurse's Room") && this.props.isSickRoom
                  && (
                    <ActionButton onClick={this.addActivity(studentId)}>
                      <Icon type="startActivity" />
                    </ActionButton>
                  )
                }
                </React.Fragment>)}
            </IconsDiv>
          }
        </ChildrenDiv>
      )
    })
  }

  getInactiveChildren() {
    const newChildren = R.clone(this.props.children.filter(
      student => (student.checkin && student.checkin.id === null)))

    return newChildren.map((student) => {
      const { checkin, id: studentId } = student
      const checkinStatus = checkin.id === null ? 'Inactive' : checkin.status
      const isNotCheckedIn = checkin.status === 'Inactive'
        || checkin.status === 'Home'
        || checkin.id === null

      return (
        <ChildrenDiv key={studentId} type={checkinStatus} isCloud={checkin.is_virtual_center}>
          <StatusDiv type={checkinStatus} isCloud={checkin.is_virtual_center} />
          <ProfileDiv onClick={this.viewProfile} >
            <ProfileDivOverlay id={studentId} onClick={this.viewProfile} />
            <ProfilePicture
              profile_image={student.profile_pictures ? student.profile_pictures['original'] : '/assets/BabyAvatar.svg'}
              type={checkinStatus}
            />
          </ProfileDiv>
          <InfoDiv>
            <InfoDivOverlay id={studentId} onClick={this.viewProfile} />
            <NameDiv>
              {checkin.is_virtual_center && <Img src="/assets/Cloud.svg" alt="type" style={{ marginRight: '2px' }} />}
              <span>{student.first_name} {student.last_name_paternal}</span>
              <StudyProgramPill>{this.getStudyProgram(student.study_program_id)}</StudyProgramPill>
              {student.pendingPayments && <Img src="/assets/Warning.svg" alt="type" />}
            </NameDiv>
            {!isNotCheckedIn && this.renderCurrentActivity(student.latest_activities)}
          </InfoDiv>
          {isNotCheckedIn ?
            <IconsDiv>
              {(!checkin.is_virtual_center ) && (
                <ActionButton onClick={this.openAssessmentModal(studentId)}>
                  <Icon type="logIn" />
                </ActionButton>
              )}
            </IconsDiv>
            :
            <IconsDiv>
              {!checkin.is_virtual_center
                && checkin.status !== "Nurse's Room"
                && this.props.isSickRoom !== false
                && (
                  <ActionButton onClick={this.addActivity(studentId)}>
                    <Icon type="startActivity" />
                  </ActionButton>
                )
              }
              {!checkin.is_virtual_center && (
                <ActionButton onClick={this.checkIn(studentId)}>
                  <Icon type={checkin.inventory_completed ? 'inventory' : 'inventoryPending'} height={30} width={30} />
                </ActionButton>
              )}
            </IconsDiv>
          }
        </ChildrenDiv>
      )
    })
  }

  getStudyProgram = (studyProgramId) => {
    const studyProgram = this.props.studyPrograms.find(program => program.id === studyProgramId)

    return studyProgram && studyProgram.name
  }

  childIsDayCareAge = (studyProgramId) => {
    const { studyPrograms, levels } = this.props
    const studyProgram = studyPrograms.find(program => program.id === studyProgramId)

    if (!studyProgram) return false

    const level = levels.find(levelProgram => levelProgram.id === studyProgram.level_id)
    return level && level.name === 'Guardería'
  }

  viewProfile = (event) => {
    this.props.viewProfile(event.target.id)
  }

  checkIn = id => () => {
    const [child] = this.props.children.filter(children => children.id === Number(id))
    this.props.openCheckIn(child)
  }

  checkOut = id => () => {
    const [child] = this.props.children.filter(children => children.id === Number(id))
    this.props.openCheckOut(child)
  }

  addActivity = id => () => {
    const [child] = this.props.children.filter(children => children.id === Number(id))
    this.props.openModal(child)
  }

  openAssessmentModal = id => () => {
    const { getHomeReport, getHelathTeacher, openAssessment, healthTeacher, children, user} = this.props
    const [child] = children.filter(children => children.id === Number(id))
    getHomeReport(child.id)
    // // TODO : descomentar cuando el rh este liberado
    if(isTeacher(user.role) && healthTeacher.length === 0){
      getHelathTeacher(this.props.user.id)
      setTimeout(() => {
        openAssessment(child)
      }, 1000)
      return false
    }
    openAssessment(child)
  }

  renderCurrentActivity = (activities) => {
    let isValid = false
    let date = null
    let currentActivity = ''
    let lastActivity = ''
    if (activities) {
      Object.keys(activities).map((value) => {
        if (moment(value, 'YYYY-MM-DD', true).isValid()) {
          isValid = true
          date = value
        }
      })
      if (this.props.categories.length === 0) {
        return null
      }
      if (isValid) {
        const act = activities[date][0]
        if (act.description && (act.description.includes('Empezó') || act.description.includes('Inició'))) {
          currentActivity = act
        } else {
          lastActivity = act
        }
      } else if (activities.length > 0) {
        for (let i = 0; i < activities.length; i += 1) {
          if (activities[i].finished_at === null) {
            currentActivity = activities[i]
          } else {
            lastActivity = activities[0]
          }
        }
      }
      if (currentActivity !== '') {
        const [category] = this.props.categories.filter(c => c.id === currentActivity.category_id)
        if (category) {
          if (category.name === 'Food') {
            const [type] = category.types.filter(t => t.id === currentActivity.type_id)
            return (
              <Status activityStatus="Activo">
                <span>{type.translations.es}</span>
              </Status>
            )
          }
          return (
            <Status activityStatus="Activo">
              <span>{category.translations.es}</span>
            </Status>
          )
        }
      }
      const [category] = this.props.categories.filter(c => c.id === lastActivity.category_id)
      if (category) {
        if (category.name === 'Food') {
          const [type] = category.types.filter(t => t.id === lastActivity.type_id)
          return (
            <Status activityStatus="Inactivo">
              <span>{type.translations.es}</span>
            </Status>
          )
        }
        return (
          <Status activityStatus="Inactivo">
            <span>{category.translations.es}</span>
          </Status>
        )
      }
    }
    return ('')
  }

  render() {
    return (
      <ChildrenContainer teacher={this.props.teacher}>
        <Tabs filter={this.props.filter} tab={this.props.tab} />
        {this.getActiveChildren()}
        {this.getInactiveChildren()}
      </ChildrenContainer>
    )
  }
}

ChildrenList.propTypes = {
  openModal: PropTypes.func,
  openCheckIn: PropTypes.func,
  openCheckOut: PropTypes.func,
  openAssessment: PropTypes.func,
  filter: PropTypes.func,
  viewProfile: PropTypes.func,
  teacher: PropTypes.bool,
  tab: PropTypes.string,
  children: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  studyPrograms: PropTypes.array.isRequired,
  levels: PropTypes.array.isRequired,
  isSickRoom: PropTypes.bool,
  director: PropTypes.bool,
}

ChildrenList.defaultProps = {
  filter: () => {},
  viewProfile: () => {},
  openModal: () => {},
  openCheckIn: () => {},
  openCheckOut: () => {},
  openAssessment: () => {},
  teacher: false,
  tab: '',
  isSickRoom: false,
  director: false,
}
const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(ChildrenList))



// WEBPACK FOOTER //
// ./src/Components/ChildrenList/index.jsx